<template>
  <v-menu
    v-model="menuContainer"
    :class="{ 'v-menu__activator--disabled': !isSuccess }"
    :close-on-content-click="false"
    :open-on-click="false"
    offset-y
  >
    <v-btn
      slot="activator"
      :disabled="!isSuccess"
      flat
      @click="toggleDropdown"
    >
      <span class="toolbar__button-label">
        <span v-if="profile" class="autocomplete__text autocomplete__text--active">{{ profile }}</span>
        <span v-else class="autocomplete__text">{{ $t('Common.by') }} {{ $t('Common.accessProfile') }}</span>
      </span>
      <v-icon right small v-if="!isSelected">keyboard_arrow_down</v-icon>
      <v-icon right small color="accent" v-if="isSelected" id="menu-item__clear" @click="toggleDropdown">close</v-icon>
    </v-btn>

    <v-list class="v-list--custom">
      <v-list-tile
        v-for="profile in profilesList"
        :key="profile.value"
        @click="getSelectedProfile(profile)"
      >
        <v-list-tile-title>{{ profile.name }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { objectToArray } from 'utils/functions'

export default {
  name: 'MenuItemProfiles',
  props: {
    status: {
      type: Number,
      default: STATUS_SUCCESS
    }
  },
  data () {
    return {
      menuContainer: false,
      profile: null,
      isSelected: false
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    profilesList () {
      const profiles = objectToArray(this.$t('Views.UserPage.form.profiles'))
      return profiles
    }
  },
  methods: {
    resetProps () {
      this.updateFilters()
      this.menuContainer = false
      this.isSelected = false
      this.profile = null
    },

    toggleDropdown ($event) {
      if ($event.target.id === 'menu-item__clear') {
        this.resetProps()
        return
      }
      this.menuContainer = true
    },

    updateFilters (profile = null) {
      this.$emit('change', { profile })
    },

    getSelectedProfile ({ value, name }) {
      this.updateFilters(value)
      this.menuContainer = false
      this.isSelected = true
      this.profile = name
    }
  }
}
</script>
